import React, { useState } from "react";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";
import SubscriptionsModal from "../components/modals/SubscriptionsModal";
import Invoice from "../components/modals/Invoice";

const SubscriptionPackages = () => {
  const [hoverActiveOne, setHoverActiveOne] = useState(false);
  const [hoverActiveTwo, setHoverActiveTwo] = useState(false);
  const [hoverActiveThree, setHoverActiveThree] = useState(false);
  const [invoice, setInvoice] = useState(false);
  const [subDetailsModal, setSubDetailsModal] = useState(false);

  const handleHoverOne = () => {
    setHoverActiveOne(!hoverActiveOne);
  };
  const handleHoverTwo = () => {
    setHoverActiveTwo(!hoverActiveTwo);
  };
  const handleHoverThree = () => {
    setHoverActiveThree(!hoverActiveThree);
  };

  const handleSubscriptionModal = () => {
    setSubDetailsModal(true);
  };

  const CloseModal = () => {
    setSubDetailsModal(false);
  };

  return (
    <>
      <div>
        <div className="flex items-center justify-center">
          <img
            src={logo}
            alt="logo"
            className="object-contain w-[20%] hero--logo"
          />
        </div>
        <p className="text-[#2F80ED] w-[30%] text-center packages--title">
          Subscription Packages
        </p>
        <div className="w-full flex justify-center mt-16">
          <div className="w-[80%] flex justify-between plans">
            {/* First Plan */}
            <div
              className={`w-[25%] flex justify-center flex-col items-center shadow-md rounded-lg plan--card ${
                hoverActiveOne ? "cardHover" : ""
              }`}
              onMouseEnter={handleHoverOne}
              onMouseLeave={handleHoverOne}
            >
              <p
                className={`text-[18px] text-[#333333] font-bold mt-5 mb-4 ${
                  hoverActiveOne ? "text-white" : ""
                }`}
              >
                Essential Exhibitor Package
              </p>
              <div className="bg-[#F0F0F0] w-full text-[24px] font-bold pl-2 py-1 text-black">
                $300
                <span className="pl-1 text-[#746E7B] text-[20px]">/month</span>
              </div>
              <div
                className={`items-center text-[#828282] text-[16px] w-[70%] justify-start pt-4 ${
                  hoverActiveOne ? "text-white" : ""
                }`}
              >
                Medium-sized exhibitors seeking post-exhibition management.
              </div>
              <div className="flex justify-center w-full mt-16 mb-4 text-white">
                <button
                  className={` w-[40%] py-2 rounded-lg bg-[#2F80ED] text-[14px] ${
                    hoverActiveOne ? "bg-white" : ""
                  } ${hoverActiveOne ? "text-[#2F80ED]" : ""}`}
                  onClick={handleSubscriptionModal}
                >
                  Get Started
                </button>
              </div>
            </div>

            {/* Second Plan */}
            <div
              className={`w-[25%] flex justify-center flex-col items-center shadow-md rounded-lg plan--card ${
                hoverActiveTwo ? "cardHover" : ""
              }`}
              onMouseEnter={handleHoverTwo}
              onMouseLeave={handleHoverTwo}
            >
              <p
                className={`text-[18px] text-[#333333] font-bold mt-5 mb-4 ${
                  hoverActiveTwo ? "text-white" : ""
                }`}
              >
                Organizer Pro
              </p>
              <div className="bg-[#F0F0F0] w-full text-[24px] font-bold pl-2 py-1 text-black">
                $500
                <span className="pl-1 text-[#746E7B] text-[20px]">/month</span>
              </div>
              <div
                className={`items-center text-[#828282] text-[16px] w-[70%] justify-start pt-4 ${
                  hoverActiveTwo ? "text-white" : ""
                }`}
              >
                Event organizers in need of comprehensive post-exhibition
                solutions for multiple exhibitors.
              </div>
              <div className="flex justify-center w-full mt-16 mb-4 text-white">
                <button
                  className={` w-[40%] py-2 rounded-lg bg-[#2F80ED] text-[14px] ${
                    hoverActiveTwo ? "bg-white" : ""
                  } ${hoverActiveTwo ? "text-[#2F80ED]" : ""}`}
                  onClick={handleSubscriptionModal}
                >
                  Get Started
                </button>
              </div>
            </div>

            {/* Third Plan */}
            <div
              className={`w-[25%] flex justify-center flex-col items-center shadow-md rounded-lg plan--card ${
                hoverActiveThree ? "cardHover" : ""
              }`}
              onMouseEnter={handleHoverThree}
              onMouseLeave={handleHoverThree}
            >
              <p
                className={`text-[18px] text-[#333333] font-bold mt-5 mb-4 ${
                  hoverActiveThree ? "text-white" : ""
                }`}
              >
                Enterprise Empowerment
              </p>
              <div className="bg-[#F0F0F0] w-full text-[24px] font-bold pl-2 py-1 text-black">
                $500
                <span className="pl-1 text-[#746E7B] text-[20px]">/month</span>
              </div>
              <div
                className={`items-center text-[#828282] text-[16px] w-[70%] justify-start pt-4 ${
                  hoverActiveThree ? "text-white" : ""
                }`}
              >
                Event organizers in need of comprehensive post-exhibition
                solutions for multiple exhibitors.
              </div>
              <div className="flex justify-center w-full mt-16 mb-4 text-white">
                <button
                  className={` w-[40%] py-2 rounded-lg bg-[#2F80ED] text-[14px] ${
                    hoverActiveThree ? "bg-white" : ""
                  } ${hoverActiveThree ? "text-[#2F80ED]" : ""}`}
                  onClick={handleSubscriptionModal}
                >
                  Get Started
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full text-center mt-16 text-[#2F80ED] underline mb-4">
          <Link to="/dashboard" className="cursor-pointer">
            skip
          </Link>
        </div>

        {subDetailsModal ? (
          <SubscriptionsModal
            CloseModal={CloseModal}
            setSubDetailsModal={setSubDetailsModal}
            setInvoice={setInvoice}
          />
        ) : (
          ""
        )}
        {invoice ? <Invoice setInvoice={setInvoice} /> : null}
      </div>
    </>
  );
};

export default SubscriptionPackages;
